"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var hulylake_exports = {};
__export(hulylake_exports, {
  HulylakeStorage: () => HulylakeStorage
});
module.exports = __toCommonJS(hulylake_exports);
var import_core = require("@hcengineering/core");
var import_upload = require("../upload");
const getPathname = /* @__PURE__ */ __name((url) => {
  const base = window?.location?.href !== void 0 ? window.location.href : "http://localhost";
  return new URL(url, base).pathname;
}, "getPathname");
class HulylakeStorage {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }
  static {
    __name(this, "HulylakeStorage");
  }
  getFileUrl(workspace, file, filename) {
    const path = `/api/${workspace}/${file}`;
    return (0, import_core.concatLink)(this.baseUrl, path);
  }
  getCookiePath(workspace) {
    const url = (0, import_core.concatLink)(this.baseUrl, `/api/${workspace}`);
    return getPathname(url);
  }
  async getFileMeta(token, workspace, file) {
    return {};
  }
  async deleteFile(token, workspace, file) {
    const url = this.getFileUrl(workspace, file);
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to delete file");
    }
  }
  async uploadFile(token, workspace, uuid, file, options) {
    const url = this.getFileUrl(workspace, uuid);
    await (0, import_upload.uploadXhr)(
      {
        url,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": file.type,
          "Content-Length": file.size.toString()
        },
        body: file
      },
      options
    );
  }
}
//# sourceMappingURL=hulylake.js.map
